<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title"><span>{{ tab_name }}</span></div>
    </div>
  </div>

  <div class="row">
    <div class="col m-10" style="margin: 20px;">
      <div style="margin-bottom: 10px;">
        This table shows {{ mode === 'public' ? 'public' : mode === 'private' ? 'private' : '' }}
        companies assigned to the same GICS peer group of the selected company based on patent similarity.
      </div>

      <!-- Peer Group Selection button — top right for custom mode -->
      <div *ngIf="mode === 'custom'" style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
        <button class="btn peer-group-selector-btn" (click)="openUniverseSelector()">
          <i class="bi bi-funnel-fill"></i> Select Peer Group
        </button>
      </div>

      <!-- Waiting for selection (custom mode, no selection yet) -->
      <div class="empty-state" *ngIf="mode === 'custom' && !hasCustomSelection" style="margin-top: 16px;">
        <div class="empty-state-content">
          <i class="bi bi-people empty-state-icon"></i>
          <h4>Select a Peer Group</h4>
          <p>Click the button above to configure your custom peer group.</p>
        </div>
      </div>

      <!-- No GICS -->
      <div class="alert alert-info" role="alert" *ngIf="mode !== 'custom' && !showResults && !loadingFailed">
        <p>This result is currently available only for companies classified under the GICS.</p>
      </div>

      <div class="card keywords" *ngIf="showResults && (mode !== 'custom' || hasCustomSelection)">
        <h3>{{ title }}</h3>

        <!-- Error -->
        <div class="alert alert-danger" role="alert" *ngIf="loadingFailed">
          <p>Unable to load results. Please try again or contact
            <a href="mailto:info@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>

        <!-- Empty state -->
        <div class="empty-state" *ngIf="showDataMissing">
          <i class="bi bi-search empty-state-icon"></i>
          <h5>No Companies Found</h5>
          <p>No {{ mode !== 'custom' ? mode : '' }} companies found for this peer group.</p>
        </div>

        <!-- Spinner -->
        <div class="spinner-border text-primary" role="status"
          *ngIf="showResults && competitors_list.length === 0 && !loadingFailed && !showDataMissing">
          <span class="visually-hidden">Loading...</span>
        </div>

        <!-- Company rank description -->
        <div class="company-category-description" *ngIf="focusedCompanyRow && competitors_list.length > 0"
          style="margin: 10px 0; background-color: #f8f9fa; border-radius: 5px; padding: 10px 15px;">
          <span [innerHTML]="getCategoryDescription()"></span>
        </div>

        <!-- Category Tabs -->
        <div class="category-tabs" *ngIf="competitors_list.length > 0 && !loadingFailed">
          <div class="tab-buttons">
            <button *ngFor="let cat of categoryTabs" class="category-tab-btn"
              [class.active]="selectedCategory === cat.key" (click)="selectCategory(cat.key)">
              {{ cat.label }}
            </button>
          </div>
          <div class="category-description" *ngIf="getCurrentCategoryDescription()">
            <p>{{ getCurrentCategoryDescription() }}
              <i class="bi bi-info-circle" [matTooltip]="getCurrentCategoryTooltip()" matTooltipPosition="above"
                style="margin-left: 8px; cursor: pointer;"></i>
            </p>
          </div>
          <div class="no-results-message" *ngIf="!hasCategoryResults()"
            style="margin: 15px 0; padding: 20px; background-color: #fff3cd; border-radius: 5px; border-left: 4px solid #ffc107; text-align: center;">
            <i class="bi bi-exclamation-triangle" style="color: #856404; margin-right: 8px;"></i>
            <strong>No companies found</strong> for <strong>{{ getCurrentCategoryLabel() }}</strong>.
          </div>
        </div>

        <!-- Filters -->
        <div class="filters" *ngIf="competitors_list.length > 0">
          <mat-slide-toggle (change)="filterFavorites()">
            Show <i class="bi bi-star"></i> Selection Only
          </mat-slide-toggle>

          <input type="text" class="form-control" placeholder="Search by Company Name" [(ngModel)]="searchQuery"
            (ngModelChange)="applyFilters()" style="width: 270px; margin-left: 20px;">

          <button *ngIf="mode !== 'private'" class="btn add-selection-to-watchlist-button" style="margin-left: 20px;"
            [disabled]="getSelectedEligibleCompanies() === 0" (click)="openAddToWatchlist()">
            <i class="bi bi-bookmark-plus"></i> Add Selection to Watchlist
          </button>

          <button class="btn search-button" style="margin-left: 20px; background: #E5E7EB; color: #1F2937;"
            (click)="downloadExcel()" matTooltip="Download Excel">
            <i class="bi bi-download"></i>
          </button>
        </div>

        <!-- Table -->
        <table class="table table-hover table-condensed" *ngIf="competitors_list.length > 0">
          <thead>
            <tr style="background-color: #96c242;">
              <th style="width: 5%;">Select</th>
              <th style="width: 5%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('rank')">
                Rank <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('rank')"></i>
              </th>
              <th style="width: 15%;">Company</th>
              <th style="width: 10%;">
                <div class="dropdown" style="font-weight: normal;">
                  <button class="btn country-dropdown-btn dropdown-toggle" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false" style="font-size: 14px;">
                    Country / <br>Market
                    <span *ngIf="(countriesControl.value?.length ?? 0) > 0" class="badge bg-light text-dark ms-1">
                      {{ countriesControl.value!.length }}
                    </span>
                  </button>
                  <div class="dropdown-menu p-3" style="width: 270px; max-height: 300px; overflow-y: auto;">
                    <div *ngFor="let region of countryFilterOptions">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <input type="checkbox" [checked]="isRegionFullySelected(region)"
                            (change)="toggleRegionSelection(region)" class="form-check-input me-2">
                          <label class="form-check-label">{{ region.region }}</label>
                        </div>
                        <button class="btn btn-sm btn-light"
                          (click)="toggleExpand(region.region); $event.stopPropagation();">
                          <i class="bi" [ngClass]="isExpanded(region.region) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </button>
                      </div>
                      <div *ngIf="isExpanded(region.region)" class="ms-3">
                        <div *ngFor="let country of region.countries" class="form-check">
                          <input type="checkbox" class="form-check-input" [id]="'v2-country-' + country.code"
                            [checked]="(countriesControl.value ?? []).includes(country.code)"
                            (change)="toggleCountrySelection(country.code)">
                          <label class="form-check-label" [for]="'v2-country-' + country.code">{{ country.name
                            }}</label>
                        </div>
                      </div>
                      <hr class="my-2" *ngIf="region !== countryFilterOptions[countryFilterOptions.length - 1]">
                    </div>
                  </div>
                </div>
              </th>
              <th style="width: 10%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('size')"
                [ngClass]="{'column-highlight-size': selectedCategory === 'size_leaders'}">
                Size (10y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  matTooltip="Invention Count (10y). Number of inventions published in the last 120 months."
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('size')"></i>
              </th>
              <th style="width: 14%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('growth')"
                [ngClass]="{'column-highlight-growth': selectedCategory === 'growth_leaders'}">
                Growth (1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  matTooltip="% Change year-over-year. Values in parentheses show inventions in last 12 months."
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('growth')"></i>
              </th>
              <th style="width: 10%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('quality')"
                [ngClass]="{'column-highlight-quality': selectedCategory === 'quality_leaders'}">
                Quality (0-100, 1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  matTooltip="Average quality score of inventions in the last 12 months."
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('quality')"></i>
              </th>
              <th style="width: 15%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='innovation_score' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('innovation_score')"
                [ngClass]="{'column-highlight-innovation': selectedCategory === 'innovation_leaders' || selectedCategory === 'upcoming'}">
                Innovation Score
                <i class="bi bi-info-circle" matTooltip="Current Innovation Score relative to GICS Peer Group."
                  style="margin-left: 5px; cursor: pointer;"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('innovation_score')"></i>
              </th>
              <th style="width: 12%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='score_change' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('score_change')"
                [ngClass]="{'column-highlight-upcoming': selectedCategory === 'upcoming'}">
                Score Change (3m)
                <i class="bi bi-info-circle" matTooltip="Change in Innovation Score in the last 3 months."
                  style="margin-left: 5px; cursor: pointer;"></i>
                <i class="bi" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('score_change')"></i>
              </th>
              <th style="width: 11%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='rank_change' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('rank_change')">
                Rank Change (%, 3m)
                <i class="bi bi-info-circle" matTooltip="Percentile ranks climbed in the last 3 months."
                  style="margin-left: 5px; cursor: pointer;"></i>
                <i class="bi" *ngIf="selectedCategory === 'all_competitors'" [ngClass]="getSortIcon('rank_change')"></i>
              </th>
              <th style="width: 5%;">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let company of filteredCompanyList | paginate: { id: paginatorId, itemsPerPage: 20, currentPage: paginator_1_page }"
              [ngClass]="company.entityid === entityid ? 'highlight' : 'normal'">
              <td>
                <button (click)="toggleCompanySelection(company)" class="btn btn-light action-star-btn"
                  [matTooltip]="isCompanySelected(company.entityid) ? 'Deselect' : 'Select'">
                  <i class="bi"
                    [ngClass]="isCompanySelected(company.entityid) ? 'bi-star-fill text-warning' : 'bi-star'"></i>
                </button>
              </td>
              <td [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'">{{ company.rank }}
              </td>
              <td>
                <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  [matTooltip]="company.entity_name || ''">
                  {{ company.entity_name }}

                </div>
                <div style="font-size: 12px; color: cadetblue;" *ngIf="company.isin">
                  {{ company.isin }}
                  <a *ngIf="company.webpage"
                    [href]="company.webpage!.startsWith('http') ? company.webpage : 'http://' + company.webpage"
                    target="_blank"><i class="bi bi-globe2" style="color: grey;"></i></a>
                </div>
                <div style="font-size: 12px; color: cadetblue;" *ngIf="!company.isin">{{ company.companytype }}</div>
              </td>
              <td>{{ company.country || '—' }}</td>
              <td [ngClass]="{'column-highlight-size': selectedCategory === 'size_leaders'}"
                [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'">
                {{ company.invention_count_120m | nullableNumber: '1.0-0' }}
              </td>
              <td [ngClass]="{'column-highlight-growth': selectedCategory === 'growth_leaders'}"
                [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'">
                <div>{{ company.relative_growth_12m | nullableNumber: '1.0-1' }} %</div>
                <div style="font-size: 12px; color: cadetblue;">({{ company.invention_count_12m | nullableNumber:
                  '1.0-0' }} inventions)</div>
              </td>
              <td [ngClass]="{'column-highlight-quality': selectedCategory === 'quality_leaders'}"
                [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'">
                {{ company.quality_score_12m | nullableNumber: '1.0-1' }}
              </td>
              <td [class.sorted-col]="sortColumn==='innovation_score'"
                [ngClass]="{'column-highlight-innovation': selectedCategory === 'innovation_leaders' || selectedCategory === 'upcoming'}">
                <div class="score-bar-container">
                  <div class="score-bar">
                    <div class="score-bar-fill" [style.background-color]="getBarColor(company.innovation_score)"
                      [style.width.%]="company.innovation_score"></div>
                  </div>
                  <span class="score-label">{{ company.innovation_score | nullableNumber: '1.0-1' }}</span>
                </div>
                <div class="signal-row" *ngIf="mode === 'public'">
                  <span
                    *ngIf="company.companytype === 'Private Company' || company.companytype === 'Private Investment Firm'">-</span>
                  <span
                    *ngIf="company.companytype === 'Public Company' || company.companytype === 'Public Investment Firm'"
                    class="signal-badge" [style.background-color]="getSignalBgColor(company.signal)"
                    [style.color]="getSignalColor(company.signal)">{{ company.signal }}</span>
                </div>
              </td>
              <td [class.sorted-col]="sortColumn==='score_change'"
                [ngClass]="{'column-highlight-upcoming': selectedCategory === 'upcoming'}">
                <div class="change-metric" *ngIf="company.score_change !== null"
                  [ngClass]="getBracketColor(company.score_bracket)"
                  [matTooltip]="getBracketTooltip(company.score_bracket)"
                  [matTooltipDisabled]="!getBracketTooltip(company.score_bracket)">
                  <i class="bi" [ngClass]="getBracketArrow(company.score_bracket)"></i>
                  <span>
                    <span *ngIf="company.score_change! >= 0.05">+</span>{{ company.score_change | nullableNumber:
                    '1.0-1' }}
                  </span>
                </div>
              </td>
              <td [class.sorted-col]="sortColumn==='rank_change'">
                <div class="change-metric" *ngIf="company.pct_rank_climbed !== null"
                  [ngClass]="getBracketColor(company.rank_bracket)"
                  [matTooltip]="getBracketTooltip(company.rank_bracket)"
                  [matTooltipDisabled]="!getBracketTooltip(company.rank_bracket)">
                  <i class="bi" [ngClass]="getBracketArrow(company.rank_bracket)"></i>
                  <span>
                    <span *ngIf="company.pct_rank_climbed! >= 0.05">+</span>{{ company.pct_rank_climbed |
                    nullableNumber: '1.0-1' }}%
                  </span>
                  <br>
                  <span style="font-weight: normal; font-size: 12px;" *ngIf="company.rank_climbed !== null">
                    (<span *ngIf="company.rank_climbed! > 0">+</span>{{ company.rank_climbed || 0 }} ranks)
                  </span>
                </div>
              </td>
              <td>
                <button class="btn search-button" (click)="newSearch(company)"
                  [disabled]="!(company.gsubind_extended || company.gsubind)" *ngIf="company.entityid !== entityid">
                  <i class="bi bi-box-arrow-up-right" style="color: black; font-size: 18px;"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <pagination-controls [id]="paginatorId" [maxSize]="5" (pageChange)="paginator_1_page = $event"
          *ngIf="filteredCompanyList.length > 0">
        </pagination-controls>


      </div>
     <div style="font-size: 10px;margin-top:20px; margin-bottom:10px;">
        <span style="font-size: 10px;margin-top:20px; margin-bottom:10px;">
        Important Notice: 
This content is provided for general informational purposes only. It reflects a quantitative assessment of a company’s innovation activity based primarily on patent-related data and does not constitute investment advice, investment brokerage, portfolio management, a personal recommendation, or an offer or solicitation to buy, sell, or hold any security. The rating shown on this page, including any “BUY”, “HOLD”, or “SELL” label, is generated by a model using patent and related innovation signals only. It does not take into account any investor’s individual investment objectives, financial situation, tax position, liquidity needs, risk tolerance, existing holdings, or suitability requirements. The model does not incorporate all factors relevant to an investment decision, including valuation, financial performance, balance sheet strength, macroeconomic conditions, governance, litigation, competitive dynamics, or market sentiment. This content must not be used as the sole basis for any investment decision. 
     </span>
      </div>
    </div>

  </div>


</div>